import { MetaData } from '../globals/classes/urlBuilder';

export class AppSettings {
	private static N: string = '';
	private static E: string = '';
	public static enforcePasswordEncryption: boolean;
	public static errorMessage: string;
	public static clientId: string;
	public static contextPath: string;
	public static multilanguage: boolean;
	public static autoRefreshRedirectUri: string;
	public static sandboxId: string;
	public static autoRefreshMinutes: number;
	public static demoUrlRetail: string;
	public static demoUrlCorporate: string;
	public static signedOutButtonRedirectUrl: string;
	private static metadataParser: MetaData = new MetaData();

	//#region Features
	public static isCustOnboardingEnabled = false;
	public static isHybridLoginEnabled = false;
	public static isNewFaqEnabled = false;
	public static skipDelegationRequest = false;
	public static isWatchDemoRetailEnabled = false;
	public static isWatchDemoCorporateEnabled = false;
	public static isNewChangePasswordModals = false;
	public static isLoginBigModalEnabled = false;
	public static isGroupUserIdsBigModalEnabled = false;
	public static isCorporateBlockedFlowEnabled = false;
	public static isNewErrorModalEnabled = false;
	public static dynatraceForExistingOnBoarding = false;
	public static isBlockUserFeature = false;
	public static newIBTerms = false;
	public static isRebrading = true;
	public static deletePassFields = false;
	//#endregion

	public static load() {
		AppSettings.contextPath = this.metadataParser.get('contextPath');
		AppSettings.N = (<HTMLInputElement>document.getElementById('N')).value;
		AppSettings.E = (<HTMLInputElement>document.getElementById('E')).value;
		AppSettings.enforcePasswordEncryption =
			this.metadataParser.get('epe').toLowerCase() == 'true';
		AppSettings.multilanguage =
			this.metadataParser.get('multilanguage').toLowerCase() == 'true';
		AppSettings.autoRefreshRedirectUri = this.metadataParser.get('arUri');
		AppSettings.sandboxId = this.metadataParser.get('sbxId');

		var autoRefreshMinutes = Number(this.metadataParser.get('arm'));
		AppSettings.autoRefreshMinutes = isNaN(autoRefreshMinutes) ? 5 : autoRefreshMinutes;

		AppSettings.isCustOnboardingEnabled =
			this.metadataParser.get('ftr_exCustOnb').toLowerCase() == 'true';
		AppSettings.isHybridLoginEnabled =
			this.metadataParser.get('ftr_hybLogin').toLowerCase() == 'true';
		AppSettings.isNewFaqEnabled = this.metadataParser.get('ftr_newFaq').toLowerCase() == 'true';
		AppSettings.skipDelegationRequest =
			this.metadataParser.get('ftr_skipDelegReq').toLowerCase() == 'true';
		AppSettings.isWatchDemoRetailEnabled =
			this.metadataParser.get('ftr_watchDemoRetail').toLowerCase() == 'true';
		AppSettings.isWatchDemoCorporateEnabled =
			this.metadataParser.get('ftr_watchDemoCorp').toLowerCase() == 'true';
		AppSettings.isNewChangePasswordModals =
			this.metadataParser.get('ftr_newChPassMdl').toLowerCase() == 'true';
		AppSettings.isLoginBigModalEnabled =
			this.metadataParser.get('ftr_loginBigMdls').toLowerCase() == 'true';
		AppSettings.isGroupUserIdsBigModalEnabled =
			this.metadataParser.get('ftr_groupIdsBigMdls').toLowerCase() == 'true';
		AppSettings.demoUrlRetail = this.metadataParser.get('demoUrl');
		AppSettings.demoUrlCorporate = this.metadataParser.get('demoUrlCorp');
		AppSettings.signedOutButtonRedirectUrl = this.metadataParser.get('signedOutButtonRedirectUrl');
		AppSettings.isCorporateBlockedFlowEnabled =
			this.metadataParser.get('ftr_corpBlocked').toLowerCase() == 'true';
		AppSettings.isNewErrorModalEnabled =
			this.metadataParser.get('ftr_newErrors').toLowerCase() == 'true';
		AppSettings.dynatraceForExistingOnBoarding =
			this.metadataParser.get('ftr_dynatrexCustOnb').toLowerCase() == 'true';
		AppSettings.isBlockUserFeature =
			this.metadataParser.get('ftr_blockUser').toLowerCase() == 'true';
		AppSettings.newIBTerms = this.metadataParser.get('ftr_newTerms').toLowerCase() == 'true';
		AppSettings.deletePassFields =
			this.metadataParser.get('ftr_deletePassFields').toLowerCase() == 'true';
	}

	public static getPropertyN() {
		return AppSettings.N;
	}

	public static getPropertyE() {
		return AppSettings.E;
	}
}
